import React from "react"
import { Button } from "reactstrap"
import LockedIndicator from "./LockedIndicator"
import { NO_PERMISSION_MESSAGE } from "../Functions/permissions"
import "./ListingTabs.css"

function ListingTabs({ tabs = [], activeTab, onChange, className = "", activeValueKey = "id" }) {
    if (!tabs.length) return null

    return (
        <div className={`bos-listing-tabs ${className}`.trim()}>
            <div className="bos-listing-tabs__rail">
                {tabs.map((tab) => (
                    <Button
                        key={tab.id}
                        type="button"
                        color="primary"
                        value={tab[activeValueKey]}
                        aria-disabled={tab.disabled ? "true" : undefined}
                        onClick={() => { if (!tab.disabled) onChange?.(tab[activeValueKey], tab) }}
                        className={[
                            "bos-listing-tabs__item",
                            activeTab === tab[activeValueKey] ? "is-active" : "",
                            tab.floatRight ? "is-right-aligned" : "",
                            tab.iconOnly ? "is-icon-only" : "",
                            tab.disabled ? "is-locked" : "",
                        ].filter(Boolean).join(" ")}
                        title={tab.name}
                        aria-label={tab.disabled ? `${tab.name} — ${NO_PERMISSION_MESSAGE}` : tab.name}
                    >
                        {tab.iconClassName && (
                            <span className="bos-listing-tabs__icon">
                                <i className={tab.iconClassName} aria-hidden="true"></i>
                            </span>
                        )}
                        {!tab.iconOnly && <span className="bos-listing-tabs__label">{tab.name}</span>}
                        {tab.disabled && <LockedIndicator decorative />}
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default ListingTabs
